import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X5LessonStore} from '../X5LessonStore';

@observer
export class TakeSnapshotControls extends React.Component<{ store: X5LessonStore }> {
  render() {
    const {store} = this.props;

    if (store.takeSnapshot === null)
      return null;

    const takeSnapshot = store.takeSnapshot;
    const version = takeSnapshot.version;
    const isPending = takeSnapshot.save?.isPending === true;

    return (<>
      <div className="row">
        <div className="col-md-4 col-xs-6">
          <div className={version.formGroupClassName}>
            <label>Version</label>
            <input type="text" className="form-control"
                   value={version.value}
                   onChange={version.onChangeHandler}
                   onBlur={version.markTouched}
                   onKeyDown={store.completeOnEnter}/>
            <div className="invalid-text">Enter version name</div>
          </div>
        </div>
        <div className="col-auto ml-auto">
          <button type="button" className="btn btn-primary"
                  disabled={isPending}
                  onClick={store.completeTakeSnapshot}> Save
          </button>
          <button type="button" className="btn btn-primary"
                  disabled={isPending}
                  onClick={store.cancel}> Cancel
          </button>
        </div>
      </div>
      <PromiseMessage label="Saving" state={takeSnapshot.save} align="right"/>
    </>);
  }
}
